import "./no-result-found.style.scss";

import { Col, Container, Row, View } from "@amzn/stencil-react-components/layout";
import { Hr } from "@amzn/stencil-react-components/layout";
import { Text } from "@amzn/stencil-react-components/text";
import { getString } from "@/common/uistringlabels/ui-string-utils";
import React, { FunctionComponent } from "react";

export const requestSoftwareUrl = getString("noResults.requestSoftwareUrl");

export interface NoResultsProps {
  searchTerm?: string | null;
}

export const NoResultsFound: FunctionComponent<NoResultsProps> = ({ searchTerm }: NoResultsProps) => (
  <Container className="no-results-details" paddingTop="S700" paddingBottom="S500">
    <View>
      <Row key={searchTerm} gridGap="S700" alignItems="center" padding={[0, 0, "S700", 0]}>
        <Col height="100%">
          <Row padding={["S400", 0, 0, 0]}>
            <Text data-details-about="details-about" fontSize="T500" className="text">
              {getString("noResults.noResults")} &apos;{searchTerm}&apos;
            </Text>
          </Row>
          <Row padding={["S400", 0, 0, 0]}>
            <Text data-details-about="details-about" fontSize="T300" className="text">
              {getString("noResults.tryOrText")}
            </Text>
            &nbsp;
            <Text data-details-about="details-about" fontSize="T300" className="text">
              &nbsp;
              <a href={requestSoftwareUrl} target="_blank" rel="Request Software noreferrer">
                {getString("noResults.requestSoftware")}
              </a>
            </Text>
          </Row>
        </Col>
      </Row>
      <Hr color="neutral30" />
    </View>
  </Container>
);
